import React from 'react'
import { BrowserRouter, Route, } from 'react-router-dom'

import Service from './Service'
import Inform from './Inform'
import ServiceStatus from './ServiceStatus'
import ServiceHistory from './ServiceHistory'

function ServiceNavigation() {
    return (
        <BrowserRouter basename="/service">
            <Route path="/" exact>
                <Service/>
            </Route>
            <Route path="/inform">
                <Inform/>
            </Route>
            <Route path="/status">
                <ServiceStatus/>
            </Route>
            <Route path="/history">
                <ServiceHistory/>
            </Route>
        </BrowserRouter>
    )
}

export default ServiceNavigation
